import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { appInsights, reactPlugin } from "./logging/telemetry.ts";
import reportWebVitals from "./logging/reportWebVitals.ts";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import "@volvo/vcdk/themes/all-semantic.css";

const aiConnString = undefined;

try {
    if (aiConnString) {
        appInsights.loadAppInsights();
        appInsights.config.connectionString = aiConnString;
        appInsights.getCookieMgr().setEnabled(false); // Disable cookies at runtime
    }
} catch { /* empty, and this is correct */ }

reportWebVitals();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <AppInsightsErrorBoundary
            onError={() => <h1>Something went wrong</h1>}
            appInsights={reactPlugin}
        >
            <App />
        </AppInsightsErrorBoundary>
    </StrictMode>
);
